/**
 * Типы шаблонов документов
 */
export enum DocsTemplates {
  /**
   * Шаблон документа на добавление адреса доставки
   */
  DELIVERY_ADDRESS = 'delivery_address',

  /**
   * Шаблон документа на добавление новой ТК
   */
  TRANSPORT_COMPANY = 'transport_company',

  /**
   * Шаблон документа "партнёрская продажа"
   */
  PARTNER_SALE = 'partner_sale',

    /**
   * Шаблон документа "импорт файлов в корзину"
   */
  CART_PRODUCT = 'cart_product',

    /**
   * Инструкция пользователя"
   */
  USER_GUIDE = 'user_guide',

    /**
   * Файл с контактной информацией"
   */
  CONTACT_INFORMATION = 'contact_information',
}
